export default {
  title: 'Suositut tuotteet',
  list: {
    empty_list: {
      title: 'Ei vielä suosittuja tuotteita.',
    },
    fields: {
      name: 'Nimi',
      orders: 'Tilaukset',
      sales: 'Myynti',
    },
  },
};
